module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/store_images/1@2x_814c76d5679149af95936c6457077ce9.png";